export default "__VITE_ASSET__CuhK9XH$__"